import { useContext } from 'react'
import { ErrorPage } from '../pages/errorPage'
import { useTranslator } from './translator/hook'
import { UserContext } from './user/provider'

export const UnsupportedDeviceError = () => {
  const { t } = useTranslator()
  const { isOnlineUser } = useContext(UserContext)
  const description = [
    'このページはパソコンでひらいてください。',
    '（タブレットやスマートフォンではひらけません）',
  ].join('<br />')

  return (
    <ErrorPage
      title="パソコンだけのコースだよ"
      description={description}
      buttonLabel={isOnlineUser ? t('back_to_town') : undefined}
      linkTo={isOnlineUser ? 'タウン' : undefined}
    />
  )
}
